import React from 'react';
import { Outlet } from 'react-router-dom';
import { WorkerProvider } from '../context/WorkerContext';
import WorkerHeader from '../components/WorkerHeader';

const WorkerLayout = () => (
  <WorkerProvider>
    <WorkerHeader />
    <Outlet />
  </WorkerProvider>
);

export default WorkerLayout;